module.exports = __webpack_public_path__ + "img/bell-gray.2398bc19.svg";